import { render, staticRenderFns } from "./InsightsSlider.vue?vue&type=template&id=cbcf8106"
import script from "./InsightsSlider.vue?vue&type=script&lang=js"
export * from "./InsightsSlider.vue?vue&type=script&lang=js"
import style0 from "./InsightsSlider.vue?vue&type=style&index=0&id=cbcf8106&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports